import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
// import { TranslateService } from '@ngx-translate/core';
import { UIChart } from 'primeng/primeng';

import { CalendarLocale } from '../../static/calendar-locale';
import { UserService } from '../../service/user.service';
import { ListModel } from '../../model/list.model';

@Component({
	styles: [''],
	selector: 'filter-query',
	templateUrl: './filter-query.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterQueryComponent implements OnInit {
	@Output() hasChange = new EventEmitter<any>();

	constructor(
		protected userService: UserService, 
		// private translateService: TranslateService
	){}

	calendarStyle = { width: '100%' }; // 'text-align': 'center'
	init_date = new Date(new Date().getFullYear(), 1, 1);
	calendarLocale = CalendarLocale;
	dateFormat = 'dd/MM/yy';
	end_date = new Date();
	delay = 600;

	@Input() checklistCount: number = 0;
	@Input() loading: boolean = false;
	@Input() unconformities = [];
	@Input() charts: UIChart[];
	@Input() disabled = false;
	@Input() showData = true;
	@Input() queryData: any = {};

	@Input() hide: string[] = [];
	@Input() show: string[] = [];

	@Input() userOptions = [];
	@Input() users: any[] = [];

	@Input() listOptionsReview: any = {};
	@Input() listOptions: any[] = [];

	processedListOptions: IProcessedList[] = []
	selectedLists: Array<number[]> = []; // index as list_id and list_value_id as value

	ngOnInit() {
		this.getUsers();
		this.processListOptions();
	}

	/**
	 * Process input listOptions for the
	 * multi-selection Prime component.
	 */
	processListOptions(): void {
		const processedList: IProcessedList[] = [];

		for (const list of this.listOptions) {
			const values: IListValue[] = [];

			for (const value of list.values) {
				values.push({
					label: value.description,
					value: value.id,
				});
			}

			processedList.push({
				list: list,
				listValues: values,
			});
		}

		this.processedListOptions = processedList;
	}

	showItem = (key: string) => this.show.includes(key);
	hiddenItem = (key: string) => this.hide.includes(key);

	validateViewValues(key: string) {
		if (this.show.length)	return this.showItem(key);
		if (this.hide.length) return !this.hiddenItem(key);
	}

	getUsers() {
		if (this.validateViewValues('user'))
		this.userService.getAll().subscribe((res) => {
				res.forEach((item) => {
						this.userOptions.push({
								label: item.name,
								value: item,
						});
				});
		});
	}

	canShowUsers = () => this.userOptions && this.userOptions.length > 0;

	emitFilter() {
		const user_id = this.users.length > 0 ? this.users.map(user => user.id) : null;
		const fields = Object.getOwnPropertyNames(this.listOptionsReview);
		const list_filters: ListFilter[] = [];

		this.selectedLists.forEach( // index as list_id
			(list_value_ids: number[], list_id: number) => { 
				if (list_value_ids.length === 0) return;

				const list_field = fields.find((field: string) =>
					list_id == this.listOptionsReview[field]
				);

				list_filters.push({
					list_value_ids,
					list_field,
					list_id,
				});
			}
		);

		const search = {
			list_filters,
			user_id,

			init_date: this.init_date.toISOString(),
			end_date: this.end_date.toISOString(),
		};

		this.hasChange.emit(search);
	}


	// translate = (key: string) => this.translateService.instant(key || "invalid");
	// tUpper = (key) => this.translate(key).toString().toUpperCase();
	// tCap = (key) => this.translate(key).charAt(0).toUpperCase() + this.translate(key).slice(1);
}


// custom aux types
interface IListValue {
	label: string, // name that will show on multiselect
	value: number, // list value id
}

interface IProcessedList {
	list: ListModel,
	listValues: IListValue[],
}

interface ListFilter {
	list_id: number,
	list_field: string,
	list_value_ids: number[],
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/component/filter-query/filter-query.component.ts